import { cx } from "class-variance-authority";

import * as backgrounds from "./backgrounds.css";
import * as theme from "./SectionContent.css";
import { SectionBackgroundVariant } from "./types";

const contentsBackgroundVariantMap: Record<SectionBackgroundVariant, string> = {
    default: backgrounds.defaultBackground,
    active: backgrounds.activeContentBackground,
    readOnly: backgrounds.readOnlyContentBackground,
};

interface SectionContentProps {
    children: React.ReactNode;
    backgroundVariant?: SectionBackgroundVariant;
    noPadding?: boolean;
}
export function SectionContent({
    children,
    noPadding = false,
    backgroundVariant = "default",
}: SectionContentProps) {
    const rootClasses = cx(
        theme.sectionContent,
        noPadding && theme.noPadding,
        contentsBackgroundVariantMap[backgroundVariant]
    );

    return <div className={rootClasses}>{children}</div>;
}
